export const GRAPHQL_QUERY = {
    hrmQueryHrhafnGenAutocodeWhere: {
        query: "query hrmQueryHrhafnGenAutocodeWhere($args: hrhafn_gen_autocode_args = {}) { data: hrhafn_gen_autocode(args: $args) { result } }",
        variables: [
            "args"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbEmployeeWhere: {
        query: "query hrmQueryHrtbEmployeeWhere($where: hrm_hrtb_employee_bool_exp = {}) { data: hrm_hrtb_employee(where: $where) { id code name email lineManager } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbEmployeeWithJobWorkerWhere: {
        query: "query hrmQueryHrtbEmployeeWithJobWorkerWhere($where: hrm_hrtb_employee_bool_exp = {}) { data: hrm_hrtb_employee(where: $where) { id code name email lineManager jobTitle: tatm_title { id code name } worker: hrtb_worker { id mobile } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbEmployeeWithPositionWhere: {
        query: "query hrmQueryHrtbEmployeeWithPositionWhere($where: hrm_hrtb_employee_bool_exp = {}) { data: hrm_hrtb_employee(where: $where) { id code name jobTitle: tatm_title { id code name } positions: hrtb_employee_positions { position: hrtb_position { department: hrtb_unit { code name path displayPath company: hrtb_unit_root { id code name } } } } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbEmployeeWithLimitOffsetWhere: {
        query: "query hrmQueryHrtbEmployeeWithLimitOffsetWhere($where: hrm_hrtb_employee_bool_exp = {}, $limit: Int = 1, $offset: Int = 0) { data: hrm_hrtb_employee(where: $where, limit: $limit, offset: $offset) { id code name email lineManager jobTitle: tatm_title { id code name } } }",
        variables: [
            "where", "limit", "offset"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbWorkerRelationWhere: {
        query: "query hrmQueryHrtbWorkerRelationWhere($where: hrm_hrtb_worker_relation_bool_exp = {}) { data: hrm_hrtb_worker_relation(where: $where) { id relationName workerId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbWorkerWithCandidateWhere: {
        query: "query hrmQueryHrtbWorkerWithCandidateWhere($where: hrm_hrtb_worker_bool_exp = {}) { data: hrm_hrtb_worker(where: $where) { id aggId fullName candidate: hrtb_candidates { id aggId fullname sourceType recruitSource } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbWorkerWhere: {
        query: "query hrmQueryHrtbWorkerWhere($where: hrm_hrtb_worker_bool_exp = {}) { data: hrm_hrtb_worker(where: $where) { id fullName aggId personalEmail } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbWorkerRefpersonWhere: {
        query: "query hrmQueryHrtbWorkerRefpersonWhere($where: hrm_hrtb_worker_refperson_bool_exp = {}) { data: hrm_hrtb_worker_refperson(where: $where) { id aggId description refPerson refTitleId relationId refTitle workerId phone companyName } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbWorkerAttachmentWhere: {
        query: "query hrmQueryHrtbWorkerAttachmentWhere($where: hrm_hrtb_worker_attachment_bool_exp = {}) { data: hrm_hrtb_worker_attachment(where: $where) { id attachmentRefno attachmentTypeId extractedInfo extractedText extraInfo } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbWorkerAddressWhere: {
        query: "query hrmQueryHrtbWorkerAddressWhere($where: hrm_hrtb_worker_address_bool_exp = {}) { data: hrm_hrtb_worker_address(where: $where) { id aggId workerId regAddress regLocalityId regFulladdress actAddress actLocalityId actFulladdress } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbCandidateWhere: {
        query: "query hrmQueryHrtbCandidateWhere($where: hrm_hrtb_candidate_bool_exp = {}) { data: hrm_hrtb_candidate(where: $where) { id aggId fullname email mobile sourceType recruitSource sourceTypeId recruitSourceId matchingDate status fresherFlg freshGraduateFlg exEmployeeFlg neverRecruitFlg neverRecruitNote exAccount autoMailFlg autoMailDate applyDate currentSalary expectedSalary totalIncome description buCode empCode } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE",
            "SCREEN_RRM_ERP_PAYMENT_LINE"
        ],
        function: []
    },
    hrmQueryHrtbCandidateWithSuggestWhere: {
        query: "query hrmQueryHrtbCandidateWithSuggestWhere($where: hrm_hrtb_candidate_bool_exp = {}, $whereGroupDetail: hrm_hrtb_cgroup_detail_bool_exp = {}, $limit: Int = 1, $offset: Int = 0) { data: hrm_hrtb_candidate(where: $where, limit: $limit, offset: $offset) { id aggId fullname email mobile groupDetails: hrtb_cgroup_details(where: $whereGroupDetail) { id aggId group: hrtb_candidate_group { id aggId details: hrtb_cgroup_details { candidate: hrtb_candidate { id aggId fullname email } } } } } }",
        variables: [
            "where",
            "whereGroupDetail",
            "limit",
            "offset"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbCandidateWithWorkerWhere: {
        query: "query hrmQueryHrtbCandidateWithWorkerWhere($where: hrm_hrtb_candidate_bool_exp = {}) { data: hrm_hrtb_candidate(where: $where) { id aggId fullname email mobile worker: hrtb_worker { personalEmail } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE",
            "SCREEN_RRM_ERP_PAYMENT_LINE"
        ],
        function: []
    },
    hrmQueryHrtbCandidateWithWorkerAttachmentWhere: {
        query: "query hrmQueryHrtbCandidateWithWorkerAttachmentWhere($where: hrm_hrtb_candidate_bool_exp = {}, $where1: hrm_hrtb_worker_attachment_bool_exp = {}) { data: hrm_hrtb_candidate(where: $where) { id worker: hrtb_worker { attachments: hrtb_worker_attachments(where: $where1) { id attachmentTypeId attachmentRefno extraInfo } } } }",
        variables: [
            "where", "where1"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE",
            "RRM_SAVED_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbCandidateForDetailMatchingWhere: {
        query: `
        query hrmQueryHrtbCandidateForDetailMatchingWhere($_eq: numeric = "", $_eq1: numeric = "", $_eq2: String = "") {
            data: hrm_hrtb_candidate(where: {id: {_eq: $_eq1}, recordStatus: {_eq: $_eq2}}) {
                sourceType
                homeAddress
                exAccount
                worker: hrtb_worker {
                id
                personalEmail
                fullName
                dob
                scanState
                scanTime
                scanLog
                gender: tatm_gender {
                    code
                    name
                }
                summaries: hrtb_worker_summaries {
                    skill: tatm_skill {
                    code
                    name
                    }
                }
                address: hrtb_worker_addresses {
                    actFulladdress
                    regFulladdress
                }
                }
            }
            requisitionCandidate: recruit_rstb_requisition_candidate(where: {id: {_eq: $_eq}}) {
                transfercnbDate
                transfercnbStatus
                transfercnbMessage
                status
            }
        }`,
        variables: [
            "_eq1", "_eq2", "_eq"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryHrtbCandidateForIdentityAcceptOfferWhere: {
        query: `
        query hrmQueryHrtbCandidateForIdentityAcceptOfferWhere($where: hrm_hrtb_candidate_bool_exp = {}) {
            data: hrm_hrtb_candidate(where: $where) {
                unemploymentAllowanceFlg
                worker: hrtb_worker {
                    id
                    nationId
                    pobId
                    ethnicityId
                    address: hrtb_worker_addresses {
                        id
                        aggId
                        regAddress
                        regLocalityId
                        regFulladdress
                        actAddress
                        actLocalityId
                        actFulladdress
                    }
                    legaldoc: hrtb_worker_legaldocs {
                        id
                        legaldocTypeId
                        identityNo
                        issueDate
                        expiredDate
                        issuePlace
                        issuePlaceId
                    }
                    attachment: hrtb_worker_attachments {
                        id
                        attachmentTypeId
                        attachmentRefno
                        extraInfo
                        usingFlg
                        type: hrtm_attachment_type {
                            id
                            code
                            name
                        }
                    }
                }
            }
        }`,
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryHrtbCandidateResumeWhere: {
        query: "query hrmQueryHrtbCandidateResumeWhere($where: hrm_hrtb_candidate_resume_bool_exp = {}) { data: hrm_hrtb_candidate_resume(where: $where) { candidateId aggId id sourceTypeId sourceType recruitSourceId recruitSource status extRequestCode internalRequestCode recommenders: hrtb_candidate_recommenders { aggId } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbWorkerQualificationWhere: {
        query: "query hrmQueryHrtbWorkerQualificationWhere($where: hrm_hrtb_worker_qualification_bool_exp = {}) { data: hrm_hrtb_worker_qualification(where: $where) { id aggId description workerId schoolYearStart schoolYearEnd schoolId receivedHardcopyFlg qualificationTypeId qualificationRateId qualificationId overseaId mainFlg majoringId issueDate gpa facultyId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE"
        ],
        function: []
    },
    hrmQueryCstbCandidateResumeWhere: {
        query: "query hrmQueryCstbCandidateResumeWhere($where: connect_cstb_candidate_resume_bool_exp = {}) { data: connect_cstb_candidate_resume(where: $where) { id aggId appCode applyDate attachmentInfo attachmentTypeId authStatus buCode campaign candidateId checkerDate checkerId createDate cvFilename cvFilepath cvInfo emailConfirm extractedInfo extractedText portfolioLink postingId recommenderEmail requisitionId status approveAiDate } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE"
        ],
        function: []
    },
    hrmQueryCstbCandidateWithSuggestWhere: {
        query: "query hrmQueryCstbCandidateWithSuggestWhere($where: connect_cstb_candidate_bool_exp = {}, $limit: Int = 1, $offset: Int = 0) { data: connect_cstb_candidate(where: $where, limit: $limit, offset: $offset) { id aggId fullName: fullName personalEmail mobile approveAiDate resumes: cstb_candidate_resumes { posting: cstb_posting { code } } } }",
        variables: [
            "where", "limit", "offset"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE"
        ],
        function: []
    },
    hrmQueryCstbCandidateDetailWhere: {
        query: `
        query hrmQueryCstbCandidateDetailWhere($where: connect_cstb_candidate_bool_exp = {}) {
            data: connect_cstb_candidate(where: $where) {
                id
                aggId
                channelId
                sourceId
                createDate
                description
                dob
                empCode
                firstName
                fullName
                gender
                homePhone
                genderId
                description
                lastName
                makerDate
                makerId
                middleName
                mobile
                nationality
                personalEmail
                porfolioLink
                linkedin
                github
                facebook
                otherPortfolio
                tenantCode
                updateDate
                updateId
                status
                code
                recommenderEmail
                behance
                avatarFile
                skillList
                candidateLocation
                resumes: cstb_candidate_resumes {
                    cvFilename
                    cvFilepath
                    cvInfo
                    emailConfirm
                    campaign
                    makerDate
                    makerId
                    attachmentInfo
                    attachmentTypeId
                    posting: cstb_posting {
                            name
                            code
                    }
                }
                channel: cstm_channel {
                    aggId
                    code
                    name
                    id
                }
                participantEvents: cstb_event_participants {
                    id
                    event: cstb_event {
                            name
                            id
                            description
                            code
                    }
                }
            }
        }`,
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE"
        ],
        function: []
    },
    hrmQuerySmtbUserSocialStatusWhere: {
        query: "query hrmQuerySmtbUserSocialStatusWhere($where: connect_smtb_user_social_status_bool_exp = {}) { data: connect_smtb_user_social_status(where: $where) { id aggId empCode emailRef userCode userStatus appCode deletedAt createDate makerDate updateDate updateId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_PROFILE"
        ],
        function: []
    },
    hrmQueryHrtbUnitWhere: {
        query: "query hrmQueryHrtbUnitWhere($where: hrm_hrtb_unit_bool_exp = {}) { data: hrm_hrtb_unit(where: $where) { id code name displayPath displayCode unitType: hrtm_unit_type { id code name } unitClass: hrtm_unit_class { id code name } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbUnitWithLimitOffsetWhere: {
        query: "query hrmQueryHrtbUnitWithLimitOffsetWhere($where: hrm_hrtb_unit_bool_exp = {}, $limit: Int = 1, $offset: Int = 0) { data: hrm_hrtb_unit(where: $where, limit: $limit, offset: $offset) { id code name displayPath displayCode emailGroup } }",
        variables: [
            "where", "limit", "offset"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbUnitWithDeptHeadHRBPWhere: {
        query: "query hrmQueryHrtbUnitWithDeptHeadHRBPWhere($where: hrm_hrtb_unit_bool_exp = {}) { data: hrm_hrtb_unit(where: $where) { id code deptHead: hrtb_employee { id code name email jobTitle: tatm_title { id code name } } deptHRBPs: hrtb_unit_hrbps { HRBP: hrtb_employee { id code name email jobTitle: tatm_title { id code name } } } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryTatmTitleWhere: {
        query: "query hrmQueryTatmTitleWhere($where: hrm_tatm_title_bool_exp = {}) { data: hrm_tatm_title(where: $where) { id code name aggId parentId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryTatmTitleWithLimitOffsetWhere: {
        query: "query hrmQueryTatmTitleWithLimitOffsetWhere($where: hrm_tatm_title_bool_exp = {}, $limit: Int = 1, $offset: Int = 0) { data: hrm_tatm_title(where: $where, offset: $offset, limit: $limit) { id code name } }",
        variables: [
            "where", "limit", "offset"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryRstbCampaignChannelWhere: {
        query: "query hrmQueryRstbCampaignChannelWhere($where: recruit_rstb_campaign_channel_bool_exp = {}) { data: recruit_rstb_campaign_channel(where: $where) { id code name aggId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_MY_POST"
        ],
        function: []
    },
    hrmQueryTatmTypeWhere: {
        query: "query hrmQueryTatmTypeWhere($where: hrm_tatm_type_bool_exp = {}) { data: hrm_tatm_type(where: $where) { id code name aggId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_MY_POST"
        ],
        function: []
    },
    hrmQueryTatmSkillWhere: {
        query: "query hrmQueryTatmSkillWhere($where: hrm_tatm_skill_bool_exp = {}) { data: hrm_tatm_skill(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryTatmSkillWithCategoryWhere: {
        query: "query hrmQueryTatmSkillWithCategoryWhere($where: hrm_tatm_skill_bool_exp = {}) { data: hrm_tatm_skill(where: $where) { id code name parentId category: tatm_skill_category { id code name } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryTatmSkillWithCategoryLimitOffsetWhere: {
        query: "query hrmQueryTatmSkillWithCategoryLimitOffsetWhere($where: hrm_tatm_skill_bool_exp = {}, $limit: Int = 1, $offset: Int = 0) { data: hrm_tatm_skill(where: $where, limit: $limit, offset: $offset) { id code name parentId category: tatm_skill_category { id code name } } }",
        variables: [
            "where", "limit", "offset"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryTatmGenderWhere: {
        query: "query hrmQueryTatmGenderWhere($where: hrm_tatm_gender_bool_exp = {}) { data: hrm_tatm_gender(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryTatmCareerPathWhere: {
        query: "query hrmQueryTatmCareerPathWhere($where: hrm_tatm_career_path_bool_exp = {}) { data: hrm_tatm_career_path(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryTatmQualificationWhere: {
        query: "query hrmQueryTatmQualificationWhere($where: hrm_tatm_qualification_bool_exp = {}) { data: hrm_tatm_qualification(where: $where) { id code name qualificationTypeId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryTatmQualificationRateWhere: {
        query: "query hrmQueryTatmQualificationRateWhere($where: hrm_tatm_qualification_rate_bool_exp = {}) { data: hrm_tatm_qualification_rate(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryTatmIndustryWhere: {
        query: "query hrmQueryTatmIndustryWhere($where: hrm_tatm_industry_bool_exp = {}) { data: hrm_tatm_industry(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryTatmSchoolWhere: {
        query: "query hrmQueryTatmSchoolWhere($where: hrm_tatm_school_bool_exp = {}) { data: hrm_tatm_school(where: $where) { id code name city schoolTypeId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryTatmMajoringWhere: {
        query: "query hrmQueryTatmMajoringWhere($where: hrm_tatm_majoring_bool_exp = {}) { data: hrm_tatm_majoring(where: $where) { id code name facultyId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryTatmFacultyWhere: {
        query: "query hrmQueryTatmFacultyWhere($where: hrm_tatm_faculty_bool_exp = {}) { data: hrm_tatm_faculty(where: $where) { id code name schoolId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryTatmLevelWhere: {
        query: "query hrmQueryTatmLevelWhere($where: hrm_tatm_level_bool_exp = {}) { data: hrm_tatm_level(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryTatmQualificationTypeWhere: {
        query: "query hrmQueryTatmQualificationTypeWhere($where: hrm_tatm_qualification_type_bool_exp = {}) { data: hrm_tatm_qualification_type(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryTatbJobWhere: {
        query: "query hrmQueryTatbJobWhere($where: hrm_tatb_job_bool_exp = {}) { data: hrm_tatb_job(where: $where) { id code name parentId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_MY_POST",
            "SCREEN_RRM_PROGRAM_EVENT"
        ],
        function: []
    },
    hrmQueryHrtmProductGroupWhere: {
        query: "query hrmQueryHrtmProductGroupWhere($where: hrm_hrtm_product_group_bool_exp = {}) { data: hrm_hrtm_product_group(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_MY_POST"
        ],
        function: []
    },
    hrmQueryHrtmSummaryTypeWhere: {
        query: "query hrmQueryHrtmSummaryTypeWhere($where: hrm_hrtm_summary_type_bool_exp = {}) { data: hrm_hrtm_summary_type(where: $where) { id code name aggId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryHrtmMaritalStatusWhere: {
        query: "query hrmQueryHrtmMaritalStatusWhere($where: hrm_hrtm_marital_status_bool_exp = {}) { data: hrm_hrtm_marital_status(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryHrtmSourceTypeWhere: {
        query: "query hrmQueryHrtmSourceTypeWhere($where: hrm_hrtm_source_type_bool_exp = {}) { data: hrm_hrtm_source_type(where: $where) { id code name description channelTypeId: parentId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryHrtmSourceTypeWithSourceCategoryWhere: {
        query: "query hrmQueryHrtmSourceTypeWithSourceCategoryWhere($where: hrm_hrtm_source_type_bool_exp = {}) { data: hrm_hrtm_source_type(where: $where) { id code name description channelTypeId: parentId category: hrtm_source_category { code } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryHrtmNationalityWhere: {
        query: "query hrmQueryHrtmNationalityWhere($where: hrm_hrtm_nationality_bool_exp = {}) { data: hrm_hrtm_nationality(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryHrtmAttachmentTypeWhere: {
        query: "query hrmQueryHrtmAttachmentTypeWhere($where: hrm_hrtm_attachment_type_bool_exp = {}) { data: hrm_hrtm_attachment_type(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryHrtmEthnicityWhere: {
        query: "query hrmQueryHrtmEthnicityWhere($where: hrm_hrtm_ethnicity_bool_exp = {}) { data: hrm_hrtm_ethnicity(where: $where) { id code name countryId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryHrtmLegaldocTypeWhere: {
        query: "query hrmQueryHrtmLegaldocTypeWhere($where: hrm_hrtm_legaldoc_type_bool_exp = {}) { data: hrm_hrtm_legaldoc_type(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryHrtmRelationWhere: {
        query: "query hrmQueryHrtmRelationWhere($where: hrm_hrtm_relation_bool_exp = {}) { data: hrm_hrtm_relation(where: $where) { id code name updateId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryPltmCountryWhere: {
        query: "query hrmQueryPltmCountryWhere($where: hrm_pltm_country_bool_exp = {}) { data: hrm_pltm_country(where: $where) { id code name aggId description code3 currencyId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryPltmLocalityWhere: {
        query: "query hrmQueryPltmLocalityWhere($where: hrm_pltm_locality_bool_exp = {}) { data: hrm_pltm_locality(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryPltmIssuingAuthoritiesWhere: {
        query: `
        query hrmQueryPltmIssuingAuthoritiesWhere($where: hrm_pltm_issuing_authorities_bool_exp = {}) {
            data: hrm_pltm_issuing_authorities(where: $where) {
                id
                code
                name
            }
        }`,
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryPltmIssuingAuthoritiesLimitOffsetWhere: {
        query: `
        query hrmQueryPltmIssuingAuthoritiesLimitOffsetWhere($where: hrm_pltm_issuing_authorities_bool_exp = {}, $limit: Int = 1, $offset: Int = 0) {
            data: hrm_pltm_issuing_authorities(where: $where, limit: $limit, offset: $offset) {
                id
                code
                name
            }
        }`,
        variables: [
            "where", "limit", "offset"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryPltmLocalityWithCountryTypeWhere: {
        query: "query hrmQueryPltmLocalityWithCountryTypeWhere($where: hrm_pltm_locality_bool_exp = {}) { data: hrm_pltm_locality(where: $where) { id code name aggId parentId countryId country: pltm_country { id code name aggId code3 } type: pltm_locality_type { id code name } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryPltmLocalityWithCountryTypeLimitOffsetWhere: {
        query: "query hrmQueryPltmLocalityWithCountryTypeLimitOffsetWhere($where: hrm_pltm_locality_bool_exp = {}, $limit: Int = 1, $offset: Int = 0) { data: hrm_pltm_locality(where: $where, limit: $limit, offset: $offset) { id code name parentId countryId country: pltm_country { id code name } type: pltm_locality_type { id code name } } }",
        variables: [
            "where", "limit", "offset"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryPstmEmailTemplateWhere: {
        query: "query hrmQueryPstmEmailTemplateWhere($where: recruit_pstm_email_template_bool_exp = {}) { data: recruit_pstm_email_template(where: $where) { id code name aggId subject body type: pstm_email_template_type { id code name } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryPstmEmailTemplateTypeWhere: {
        query: "query hrmQueryPstmEmailTemplateTypeWhere($where: recruit_pstm_email_template_type_bool_exp = {}) { data: recruit_pstm_email_template_type(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryRstmExclusionTypeWhere: {
        query: "query hrmQueryRstmExclusionTypeWhere($where: recruit_rstm_exclusion_type_bool_exp = {}) { data: recruit_rstm_exclusion_type(where: $where) { id code name details: rstb_exclusion_details { aggId exclusionDatas } } }",
        variables: [
            "where"
        ],
        screen: [
            "CORE_RRM_ERP_EXCLUSION"
        ],
        function: []
    },
    hrmQueryRstmReferralPaymentWhere: {
        query: "query hrmQueryRstmReferralPaymentWhere($where: recruit_rstm_referral_payment_bool_exp = {}) { data: recruit_rstm_referral_payment(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryRstmSurveyTypeWhere: {
        query: "query hrmQueryRstmSurveyTypeWhere($where: recruit_rstm_survey_type_bool_exp = {}) { data: recruit_rstm_survey_type(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_SURVEY_RESPONSE",
            "SCREEN_RRM_QUESTION_SURVEY",
            "SCREEN_RRM_QUESTIONNAIRE_SURVEY"
        ],
        function: []
    },
    hrmQueryPstbProgramWhere: {
        query: "query hrmQueryPstbProgramWhere($where: recruit_pstb_program_bool_exp = {}) { data: recruit_pstb_program(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryPstbEventWhere: {
        query: "query hrmQueryPstbEventWhere($where: recruit_pstb_event_bool_exp = {}) { data: recruit_pstb_event(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryCstbPostingChannelWhere: {
        query: "query hrmQueryCstbPostingChannelWhere($where: connect_cstb_posting_channel_bool_exp = {}) { data: connect_cstb_posting_channel(where: $where) { channelId tenantCode aggId channel: cstm_channel { code description name id } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_MY_POST"
        ],
        function: []
    },
    hrmQueryCstbPostingWhere: {
        query: "query hrmQueryCstbPostingWhere($where: connect_cstb_posting_bool_exp = {}) { data: connect_cstb_posting(where: $where) { id aggId code name city buCode createDate endDate hotJobFlg hashtag jobCategory jobGroup jobLevel jobTitle jobType partnerId partnerInfo productGroup sellingPoint personalLevel tenantCode startDate specialNote requirement description note status slug channels: cstb_posting_channels { channel: cstm_channel { code name } aggId description } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_MY_POST"
        ],
        function: []
    },
    hrmQueryCstmChannelWhere: {
        query: "query hrmQueryCstmChannelWhere($where: connect_cstm_channel_bool_exp = {}) { data: connect_cstm_channel(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_MY_POST"
        ],
        function: []
    },
    hrmQueryCstbEventWhere: {
        query: "query hrmQueryCstbEventWhere($where: connect_cstb_event_bool_exp = {}) { data: connect_cstb_event(where: $where) { id code name updateId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryRstmReferralProgramWhere: {
        query: "query hrmQueryRstmReferralProgramWhere($where: recruit_rstm_referral_program_bool_exp = {}) { data: recruit_rstm_referral_program(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstmChannelWhere: {
        query: "query hrmQueryRstmChannelWhere($where: recruit_rstm_channel_bool_exp = {}) { data: recruit_rstm_channel(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryRstbCampaignStakeholderWhere: {
        query: "query hrmQueryRstbCampaignStakeholderWhere($where: recruit_rstb_campaign_stakeholder_bool_exp = {}) { data: recruit_rstb_campaign_stakeholder(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_MY_POST"
        ],
        function: []
    },
    hrmQueryQstbSurveyForRefCheckWhere: {
        query: "query hrmQueryQstbSurveyForRefCheckWhere($where: recruit_qstb_survey_bool_exp = {}) { data: recruit_qstb_survey(where: $where) { questionnaire: qstm_questionnaire { id code } question: qstb_question { id code questionText } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryQstbQuestionWhere: {
        query: "query hrmQueryQstbQuestionWhere($where: recruit_qstb_question_bool_exp = {}) { questions: recruit_qstb_question(where: $where) { id code questionTypeId requiredFlg } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_PROGRAM_EVENT"
        ],
        function: []
    },
    hrmQueryHrtbOfficeWithLocalityWhere: {
        query: "query hrmQueryHrtbOfficeWithLocalityWhere($where: hrm_hrtb_office_bool_exp = {}) { data: hrm_hrtb_office(where: $where) { id code name aggId cityId fullAddress locality: pltm_locality { id code name countryId } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryHrtbOfficeWhere: {
        query: "query hrmQueryHrtbOfficeWhere($where: hrm_hrtb_office_bool_exp = {}) { data: hrm_hrtb_office(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryPstbEventDrawWhere: {
        query: "query hrmQueryPstbEventDrawWhere($where: recruit_pstb_event_draw_bool_exp = {}) { data: recruit_pstb_event_draw(where: $where) { winnerId updateId updateDate status drawDate drawCode gift: pstb_event_gift { code name description brandName buCode giftTypeId supplier } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    // not use hrmQueryRstbRequisitionRecommenderWhere
    // hrmQueryRstbRequisitionRecommenderWhere: {
    //     query: "query hrmQueryRstbRequisitionRecommenderWhere($where: recruit_rstb_requisition_recommender_bool_exp = {}) { data: recruit_rstb_requisition_recommender(where: $where) { erpStatus recommender } }",
    //     variables: [
    //         "where"
    //     ],
    //     screen: [
    //         "SCREEN_RRM_TASK",
    //         "SCREEN_RRM_TRACKING",
    //         "SCREEN_RRM_CANDIDATE"
    //     ],
    //     function: []
    // },
    hrmQueryRstbRequisitionCandidateWhere: {
        query: "query hrmQueryRstbRequisitionCandidateWhere($where: recruit_rstb_requisition_candidate_bool_exp = {}) { data: recruit_rstb_requisition_candidate(where: $where) { id aggId candidateId requisitionId jobId requisitionCandidateId: id reqCandidateStatus: status rootWorkflowId workflowId taskId taskKey taskStatus offerStatus matchingId matchingDate } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryRstbRequisitionCandidateWithRequisitionWhere: {
        query: `
        query hrmQueryRstbRequisitionCandidateWithRequisitionWhere($_eq: numeric = "") {
            data: recruit_rstb_requisition_candidate(where: {candidateId: {_eq: $_eq}}) {
                id
                aggId
                requisition: rstb_requisition {
                    id
                    code
                }
            }
        }`,
        variables: [
            "_eq"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryRstbRequisitionCandidateWithWorkerWhere: {
        query: "query hrmQueryRstbRequisitionCandidateWithWorkerWhere($where: recruit_rstb_requisition_candidate_bool_exp = {}) { data: recruit_rstb_requisition_candidate(where: $where) { candidate: hrm_hrtb_candidate { worker: hrtb_worker { fullName personalEmail } } requisition: rstb_requisition { code } id candidateId requisitionId taskId taskKey status workflowId rootWorkflowId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryRstbRequisitionCandidateWithRecommenderWhere: {
        query: `
        query hrmQueryRstbRequisitionCandidateWithRecommenderWhere($_eq: numeric = "", $_in: [String!] = []) {
            data: recruit_rstb_requisition_candidate(where: {candidateId: {_eq: $_eq}, rstb_requisition: {code: {_in: $_in}}}) {
                displayStatus
                status
                taskKey
                requisition: rstb_requisition {
                    code
                }
                recommenders: rstb_requisition_recommenders {
                    recommender
                    recommenderInfo
                    erpStatus
                }
            }
        }`,
        variables: [
            "_eq", "_in"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryRstbRequisitionCandidateWithInterviewWhere: {
        query: `
        query hrmQueryRstbRequisitionCandidateWithInterviewWhere($where: recruit_rstb_requisition_candidate_bool_exp = {}) {
            data: recruit_rstb_requisition_candidate(where: $where) {
                id
                status
                displayStatus
                workflowId
                requisitionId
                candidateId
                candidate: hrm_hrtb_candidate {
                    fullname
                }
                requisition: rstb_requisition {
                    id
                    aggId
                    code
                    name
                    buCode
                    hiringManager
                    requisitionJob: rstb_requisition_jobs {
                        jobTitle
                    }
                }
                interviews: rstb_interviews(order_by: {id: desc}) {
                    id
                    round: rstm_interview_round {
                        name
                    }
                }
            }
        }`,
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryRstbRequisitionCandidateAllDisplayStatus: {
        query: "query hrmQueryRstbRequisitionCandidateAllDisplayStatus($distinct_on: [recruit_rstb_requisition_candidate_select_column!] = displayStatus) { data: recruit_rstb_requisition_candidate(distinct_on: $distinct_on) { displayStatus } }",
        variables: [
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_HOME"
        ],
        function: []
    },
    hrmQueryViewCurrentCandidateEmailWhere: {
        query: "query hrmQueryViewCurrentCandidateEmailWhere($where: hrm_v_current_candidate_email_bool_exp = {}) { data: hrm_v_current_candidate_email(where: $where) { id contact_email personal_email } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstbAssignmentWhere: {
        query: `
        query hrmQueryRstbAssignmentWhere($where: recruit_rstb_assignment_bool_exp = {}) {
            data: recruit_rstb_assignment(where: $where) {
                id
                aggId
                requisitionCandidateId
                code
                requirement
                description
                sendingSchedule
                deadline
                assignmentLink
                status
                extraInfo
                attachments: rstb_assignment_attachments {
                    id
                    assignmentId
                    attachmentRefno
                    extraInfo
                    createDate
                    description
                    type: hrtm_attachment_type {
                        id
                        code
                        name
                    }
                }
            }
        }`,
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbCandidateGroupWhere: {
        query: `
        query hrmQueryHrtbCandidateGroupWhere($where: hrm_hrtb_candidate_group_bool_exp = {}, $where1: hrm_hrtb_cgroup_detail_bool_exp = {}) {
            data: hrm_hrtb_candidate_group(where: $where) {
                id
                details: hrtb_cgroup_details(where: $where1) {
                    id
                    aggId
                    candidateGroupId
                    candidateId
                    primaryFlg
                    hrtb_candidate {
                        hrtb_worker {
                            aggId
                            id
                            dob
                            fullName
                            mobile
                            personalEmail
                            hrtb_worker_addresses {
                                actFulladdress
                                regFulladdress
                            }
                        }
                    }
                }
            }
        }`,
        variables: [
            "where", "where1"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE_GROUP"
        ],
        function: []
    },
    hrmQueryHrtbCandidateRecommenderWhere: {
        query: "query hrmQueryHrtbCandidateRecommenderWhere($where: hrm_hrtb_candidate_recommender_bool_exp = {}) { data: hrm_hrtb_candidate_recommender(where: $where) { aggId recommender recommenderInfo erpStatus employeeInfo: hrtb_employee { id code name email } candidateResume: hrtb_candidate_resume { candidateId } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstbRequisitionDraftWhere: {
        query: "query hrmQueryRstbRequisitionDraftWhere($where: recruit_rstb_requisition_draft_bool_exp = {}) { data: recruit_rstb_requisition_draft(where: $where) { id props procDefCode } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstbOdooApprovalHistoryWhere: {
        query: "query hrmQueryRstbOdooApprovalHistoryWhere($where: recruit_rstb_odoo_approval_history_bool_exp = {}) { data: recruit_rstb_odoo_approval_history(where: $where) { login oldState newState comment createDate } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstbOdooJobApprovalHistoryWhere: {
        query: "query hrmQueryRstbOdooJobApprovalHistoryWhere($where: recruit_rstb_odoo_job_approval_history_bool_exp = {}) { data: recruit_rstb_odoo_job_approval_history(where: $where) { login oldState newState comment createDate } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstbRequisitionCandidateActLogWhere: {
        query: "query hrmQueryRstbRequisitionCandidateActLogWhere($where: recruit_rstb_requisition_candidate_bool_exp = {}) { data: recruit_rstb_requisition_candidate(where: $where) { requisitionCandidateId: id offers: rstb_requisition_offers { offerId: id } interviews: rstb_interviews { interviewId: id details: rstb_interview_details { interviewDetailId: id } } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryHrtbCandidateActLogWhere: {
        query: "query hrmQueryHrtbCandidateActLogWhere($where: hrm_hrtb_candidate_bool_exp = {}) { data: hrm_hrtb_candidate(where: $where) { id hrtb_candidate_resumes { id hrtb_candidate_recommenders { id } } hrtb_worker { id hrtb_worker_address: hrtb_worker_addresses { id } hrtb_worker_attachment: hrtb_worker_attachments { id } hrtb_worker_language: hrtb_worker_languages { id } hrtb_worker_legaldoc: hrtb_worker_legaldocs { id } hrtb_worker_qualification: hrtb_worker_qualifications { id } hrtb_worker_record: hrtb_worker_records { id } hrtb_worker_refperson: hrtb_worker_refpeople { id } hrtb_worker_relation: hrtb_worker_relations { id } hrtb_worker_social: hrtb_worker_socials { id } hrtb_worker_summary: hrtb_worker_summaries { id } } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryPstbEventParticipantActLogWhere: {
        query: "query hrmQueryPstbEventParticipantActLogWhere($where: recruit_pstb_event_participant_bool_exp = {}) { data: recruit_pstb_event_participant(where: $where) { id participant: hrtb_participant { id hrtb_worker { id hrtb_worker_address: hrtb_worker_addresses { id } hrtb_worker_attachment: hrtb_worker_attachments { id } hrtb_worker_language: hrtb_worker_languages { id } hrtb_worker_legaldoc: hrtb_worker_legaldocs { id } hrtb_worker_qualification: hrtb_worker_qualifications { id } hrtb_worker_record: hrtb_worker_records { id } hrtb_worker_refperson: hrtb_worker_refpeople { id } hrtb_worker_relation: hrtb_worker_relations { id } hrtb_worker_social: hrtb_worker_socials { id } hrtb_worker_summary: hrtb_worker_summaries { id } } } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryRstbRequisitionForMatchingWhenApproveWhere: {
        query: "query hrmQueryRstbRequisitionForMatchingWhenApproveWhere($where: recruit_rstb_requisition_bool_exp = {}) { data: recruit_rstb_requisition(where: $where) { id job: rstb_requisition_jobs { id aggId jobId } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_ONLINE_CANDIDATE"
        ],
        function: []
    },
    hrmQueryRstbRequisitionWhere: {
        query: "query hrmQueryRstbRequisitionWhere($where: recruit_rstb_requisition_bool_exp = {}) { data: recruit_rstb_requisition(where: $where) { id code status delayNote surveyFlg reasonNotSurvey refId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_CORE_RRM_ERP_CONFIG"
        ],
        function: []
    },
    hrmQueryRstbRequisitionWithLimitOffsetWhere: {
        query: "query hrmQueryRstbRequisitionWithLimitOffsetWhere($where: recruit_rstb_requisition_bool_exp = {}, $limit: Int = 1, $offset: Int = 0) { data: recruit_rstb_requisition(where: $where, limit: $limit, offset: $offset) { id code status } }",
        variables: [
            "where", "limit", "offset"
        ],
        screen: [
            "SCREEN_CORE_RRM_ERP_CONFIG"
        ],
        function: []
    },
    hrmQueryRstbRequisitionOffsetWhere: {
        query: "query hrmQueryRstbRequisitionOffsetWhere($where: recruit_rstb_requisition_offer_bool_exp = {}) { data: recruit_rstb_requisition_offer(where: $where) { id lineManagerId reportTo mentorId mentor departmentId department teamId team marketId market locationId workingPlace groupCompanyId groupCompany workingFor jobTypeId jobType offerDate jobTitleId titleOffer careerPathId careerPathOffer jobFamilyId jobFamilyOffer jobGroupId jobGroupOffer jobSubgroupId jobSubgroupOffer jobLevelId jobLevelOffer probationaryTypeId probationaryType employeeType employeeTypeId startDate salary probationSalary currencyId currency cancelOfferDate f2pBonusFlg c2pBonusFlg exEmployee exceptionAccountFlg createAccountFlg assetFlg notedForCnb notedForIfnaf directErp probationMonth seniority probationStartDate probationEndDate } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstdRequisitionOffsetWhere: {
        query: "query hrmQueryRstdRequisitionOffsetWhere($where: recruit_rstd_requisition_offer_bool_exp = {}) { data: recruit_rstd_requisition_offer(where: $where) { id lineManagerId reportTo mentorId mentor departmentId department teamId team marketId market locationId workingPlace groupCompanyId groupCompany workingFor jobTypeId jobType offerDate jobTitleId titleOffer careerPathId careerPathOffer jobFamilyId jobFamilyOffer jobGroupId jobGroupOffer jobSubgroupId jobSubgroupOffer jobLevelId jobLevelOffer probationaryTypeId probationaryType employeeType employeeTypeId startDate salary probationSalary currencyId currency cancelOfferDate f2pBonusFlg c2pBonusFlg exEmployee exceptionAccountFlg createAccountFlg assetFlg notedForCnb notedForIfnaf directErp probationMonth seniority probationStartDate probationEndDate } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstbReferenceCheckWhere: {
        query: `
        query hrmQueryRstbReferenceCheckWhere($where: recruit_rstb_reference_check_bool_exp = {}) {
            data: recruit_rstb_reference_check(where: $where) {
                surveys: rstb_refcheck_surveys {
                    answerText
                    answerDate
                    id
                    questionnaireId
                    questionId
                }
                startDate
                status
                referenceEmail
                referenceMobile
                requisitionCandidateId
                referenceName
                relationId
                organization
                notes
                leavingReason
                endDate
                makerDate
                conductedBy
                aggId
                candidateSow
                requisitionCandidate: rstb_requisition_candidate {
                    requisition: rstb_requisition {
                        code
                    }
                }
            }
        }`,
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_ONLINE_CANDIDATE"
        ],
        function: []
    },
    hrmQueryRstbSavedDetailWhere: {
        query: "query hrmQueryRstbSavedDetailWhere($where: recruit_rstb_saved_detail_bool_exp = {}) { data: recruit_rstb_saved_detail(where: $where) { candidateId candidateAggId onlineCandidateId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_SAVED_CANDIDATE"
        ],
        function: []
    },
    hrmQueryRstbSavedListWithLimitOffsetWhere: {
        query: "query hrmQueryRstbSavedListWithLimitOffsetWhere($where: recruit_rstb_saved_list_bool_exp = {}, $limit: Int = 1, $offset: Int = 0) { data: recruit_rstb_saved_list(where: $where, limit: $limit, offset: $offset) { id code name } }",
        variables: [
            "where", "limit", "offset"
        ],
        screen: [
            "SCREEN_RRM_SAVED_CANDIDATE"
        ],
        function: []
    },
    hrmQueryRstbSavedListWhere: {
        query: "query hrmQueryRstbSavedListWhere($where: recruit_rstb_saved_list_bool_exp = {}) { data: recruit_rstb_saved_list(where: $where) { id code name aggId recordStatus } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_SAVED_CANDIDATE"
        ],
        function: []
    },
    hrmQueryRstbReasonWhere: {
        query: "query hrmQueryRstbReasonWhere($where: recruit_rstb_reason_bool_exp = {}) { data: recruit_rstb_reason(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstbReasonDeploymentWhere: {
        query: "query hrmQueryRstbReasonDeploymentWhere($where: recruit_rstb_reason_deployment_bool_exp = {}) { data: recruit_rstb_reason_deployment(where: $where) { reason: rstb_reason { id code name } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstmReqTypeWhere: {
        query: "query hrmQueryRstmReqTypeWhere($where: recruit_rstm_req_type_bool_exp = {}) { data: recruit_rstm_req_type(where: $where) { id code name } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_HOME"
        ],
        function: []
    },
    hrmQueryRstbTrackingWhere: {
        query: "query hrmQueryRstbTrackingWhere($where: recruit_rstb_tracking_bool_exp = {}) { data: recruit_rstb_tracking(where: $where) { id requisitionCandidateId trackerId tracker functionalNote nonFunctionalNote othersNote updateDate } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstbInterviewJustStatusWhere: {
        query: "query hrmQueryRstbInterviewJustStatusWhere($where: recruit_rstb_interview_bool_exp = {}) { data: recruit_rstb_interview(where: $where, order_by: {id: desc}) { id status } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstbInterviewWhere: {
        query: `
        query hrmQueryRstbInterviewWhere($where: recruit_rstb_interview_bool_exp = {}, $where1: recruit_rstm_interview_round_bool_exp = {}) {
            interviews: recruit_rstb_interview(where: $where, order_by: {id: desc}) {
                id
                status
                functionalInterviewer
                functionalInterviewerId
                interviewCreator
                requisitionCandidateId
                interviewStarttime
                interviewEndtime
                timezoneName
                meetingLink
                calendarId
                interviewLocation
                interviewTypeId
                channel
                updateDate
                meetingOfficeRef
                meetingRoomRef
                interviewType: rstm_interview_type {
                    id
                    code
                    name
                }
                round: rstm_interview_round {
                    id
                    code
                    name
                    recordOrder
                }
                interviewers: rstb_assessment_interviews(order_by: {updateDate: desc}) {
                    id
                    interviewerId
                    interviewerName
                    interviewerEmail
                    interviewerRole
                    interviewerInfo
                    functionalNote
                    nonFunctionalNote
                    othersNote
                    resultFlg
                    updateDate
                    checkerDate
                    keepInViewFlg
                }
                results: rstb_interview_results {
                    interviewerId
                    interviewerName
                    interviewerEmail
                    resultFlg
                    details: rstb_interview_result_details {
                        evaluationId
                        evaluationNote
                    }
                }
                details: rstb_interview_details {
                    jobTitle
                    jobLevel
                    currentSalary
                    expectedSalary
                    longtermCommitment
                    overtimeAbility
                    allowance
                    bonus
                }
                attachments: rstb_interview_attachments {
                    attachmentRefno
                    extraInfo
                }
            }
            rounds: recruit_rstm_interview_round(where: $where1, order_by: {id: asc, recordOrder: asc}) {
                id
                code
                name
                recordOrder
            }
        }`,
        variables: [
            "where", "where1"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstbAssessmentScreeningWhere: {
        query: "query hrmQueryRstbAssessmentScreeningWhere($where: recruit_rstb_assessment_screening_bool_exp = {}) { data: recruit_rstb_assessment_screening(where: $where) { id requisitionCandidateId functionalNote nonFunctionalNote othersNote updateDate currentSalary expectedSalary allowance bonus } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryViewStakeHolderDeptHeadWhere: {
        query: "query hrmQueryViewStakeHolderDeptHeadWhere($where: recruit_v_stake_holder_dept_head_bool_exp = {}) { data: recruit_v_stake_holder_dept_head(where: $where) { employeeId employeeCode employeeName employeeEmail stakeHolderId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryMasterDataBookingInterviewWhere: {
        query: "query hrmQueryMasterDataBookingInterviewWhere($where: recruit_rstm_interview_type_bool_exp = {}, $where1: hrm_hrtb_office_bool_exp = {}) { interviewType: recruit_rstm_interview_type(where: $where) { id code name } workingPlace: hrm_hrtb_office(where: $where1) { id code name address locationLink } }",
        variables: [
            "where", "where1"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryMasterDataRequestWhere: {
        query: "query hrmQueryMasterDataRequestWhere($where: recruit_rstb_reason_bool_exp = {}, $where1: recruit_rstm_req_type_bool_exp = {}, $where2: hrm_hrtb_unit_bool_exp = {}, $where3: hrm_tatm_level_bool_exp = {}, $where4: hrm_tatm_type_bool_exp = {}, $where5: hrm_hrtb_office_bool_exp = {}) { reasonCancel: recruit_rstb_reason(where: $where) { id code name } reqType: recruit_rstm_req_type(where: $where1) { id code name } company: hrm_hrtb_unit(where: $where2) { id code name displayCode legals: hrtb_legal_entities { recordStatus country: pltm_country { id code name } } } personLevel: hrm_tatm_level(where: $where3) { id code name } jobType: hrm_tatm_type(where: $where4) { id code name } workingPlace: hrm_hrtb_office(where: $where5) { id code name } }",
        variables: [
            "where", "where1", "where2", "where3", "where4", "where5"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryMasterDataRequestWithJobWhere: {
        query: "query hrmQueryMasterDataRequestWithJobWhere($where: hrm_tatm_qualification_bool_exp = {}, $where1: hrm_tatm_career_path_bool_exp = {}, $where2: hrm_tatb_job_bool_exp = {}, $where3: hrm_tatm_skill_bool_exp = {}, $where4: recruit_rstm_referral_program_bool_exp = {}, $where5: recruit_v_stake_holder_dept_head_bool_exp = {}) { educationLevel: hrm_tatm_qualification(where: $where) { id code name } jobTrack: hrm_tatm_career_path(where: $where1) { id code name } jobFamily: hrm_tatb_job(where: $where2) { id code name } skill: hrm_tatm_skill(where: $where3) { id code name } specialERP: recruit_rstm_referral_program(where: $where4) { id aggId code name } handleBy: recruit_v_stake_holder_dept_head(where: $where5) { employeeId employeeCode employeeName employeeEmail stakeHolderId } }",
        variables: [
            "where", "where1", "where2", "where3", "where4", "where5"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryKstbGoalWhere: {
        query: `
        query hrmQueryKstbGoalWhere($where: kpi_kstb_goal_bool_exp = {}) {
            deptGoal: kpi_kstb_goal(where: $where) {
                id
                code
                name
                parentId
                targetValue
                recordStatus
                deptAssignment: kstb_goal_assignments {
                    id
                    assignedEmpid
                    assignedBuid
                    targetValue
                    actualValue
                    priority
                    recordStatus
                }
                empGoals: kstb_goals {
                    id
                    code
                    name
                    parentId
                    targetValue
                    recordStatus
                    empAssignments: kstb_goal_assignments {
                        id
                        assignedEmpid
                        assignedBuid
                        targetValue
                        actualValue
                        priority
                        recordStatus
                    }
                }
            }
        }`,
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryMasterDataGoalWhere: {
        query: `
        query hrmQueryMasterDataGoalWhere($where1: kpi_kstm_category_bool_exp = {}, $where2: kpi_kstm_type_bool_exp = {}, $where3: recruit_v_stake_holder_dept_head_bool_exp = {}) {
            category: kpi_kstm_category(where: $where1) {
                id
                code
                name
            }
            type: kpi_kstm_type(where: $where2) {
                id
                code
                name
            }
            handleBy: recruit_v_stake_holder_dept_head(where: $where3) {
                employeeId
                employeeCode
                employeeName
                employeeEmail
                stakeHolderId
            }
        }`,
        variables: [
            "where1", "where2", "where3"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryMasterDataAcceptOfferWhere: {
        query: "query hrmQueryMasterDataAcceptOfferWhere($where: hrm_pltm_country_bool_exp = {}, $where1: hrm_hrtm_legaldoc_type_bool_exp = {}, $where2: hrm_hrtm_attachment_type_bool_exp = {}) { country: hrm_pltm_country(where: $where) { id code name } legalDocType: hrm_hrtm_legaldoc_type(where: $where1) { id code name } attachmentType: hrm_hrtm_attachment_type(where: $where2) { id code name } }",
        variables: [
            "where", "where1", "where2"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryMasterDataGoalForInsertWhere: {
        query: "query hrmQueryMasterDataGoalForInsertWhere($where: recruit_rstm_sholder_unit_bool_exp = {}, $where1: kpi_kstm_category_bool_exp = {}, $where2: kpi_kstm_type_bool_exp = {}) { recruiterUnit: recruit_rstm_sholder_unit(where: $where) { unitRefId } category: kpi_kstm_category(where: $where1) { id code name } type: kpi_kstm_type(where: $where2) { id code name } }",
        variables: [
            "where", "where1", "where2"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryMasterDataOfferWhere: {
        query: "query hrmQueryMasterDataOfferWhere($where: hrm_hrtm_worker_type_bool_exp = {}, $where1: hrm_hrtb_market_bool_exp = {}, $where2: hrm_hrtb_unit_bool_exp = {}, $where3: hrm_hrtb_unit_bool_exp = {}, $where4: hrm_tatm_level_bool_exp = {}, $where5: hrm_hrtm_currency_bool_exp = {}) { employeeType: hrm_hrtm_worker_type(where: $where) { id code name } market: hrm_hrtb_market(where: $where1) { id code name } groupCompany: hrm_hrtb_unit(where: $where2) { id code name displayCode } workingFor: hrm_hrtb_unit(where: $where3) { id code name displayCode parentId legals: hrtb_legal_entities { recordStatus country: pltm_country { id code name } } } personLevel: hrm_tatm_level(where: $where4) { id code name } currency: hrm_hrtm_currency(where: $where5) { id code name } }",
        variables: [
            "where", "where1", "where2", "where3", "where4", "where5"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryMasterDataOfferWithJobWhere: {
        query: "query hrmQueryMasterDataOfferWithJobWhere($where: hrm_tatm_type_bool_exp = {}, $where1: hrm_hrtb_office_bool_exp = {}, $where2: hrm_hrtm_probationary_type_bool_exp = {}, $where3: hrm_tatm_career_path_bool_exp = {}, $where4: hrm_tatb_job_bool_exp = {}) { jobType: hrm_tatm_type(where: $where) { id code name } workingPlace: hrm_hrtb_office(where: $where1) { id code name } probationaryType: hrm_hrtm_probationary_type(where: $where2) { id code name } careerTrack: hrm_tatm_career_path(where: $where3) { id code name } jobFamily: hrm_tatb_job(where: $where4) { id code name } }",
        variables: [
            "where", "where1", "where2", "where3", "where4"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstbRequisitionForCountDoneCandidateWhere: {
        query: "query hrmQueryRstbRequisitionForCountDoneCandidateWhere($where: recruit_rstb_requisition_bool_exp = {}, $where1: recruit_rstb_requisition_candidate_bool_exp = {}, $where2: recruit_rstb_requisition_candidate_bool_exp = {}) { requisition: recruit_rstb_requisition(where: $where) { jobs: rstb_requisition_jobs { jobQuantity } } requisitionAggregate: recruit_rstb_requisition_candidate_aggregate(where: $where1) { aggregate { count(columns: aggId, distinct: true) } } requisitionAggregateOther: recruit_rstb_requisition_candidate_aggregate(where: $where2) { aggregate { count(columns: aggId, distinct: true) } } }",
        variables: [
            "where", "where1", "where2"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstbRequisitionCandidateForCheckWhere: {
        query: "query hrmQueryRstbRequisitionCandidateForCheckWhere($where: recruit_rstb_requisition_candidate_bool_exp = {}) { checkCandidateRequisition: recruit_rstb_requisition_candidate(where: $where) { id requisitionId candidateId status taskKey taskStatus candidate: hrm_hrtb_candidate { aggId changeEmpTypeFlg staffMovementFlg } requisition: rstb_requisition { id code } } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstbRequisitionCandidateForValidTransferWhere: {
        query: `
        query hrmQueryRstbRequisitionCandidateForValidTransferWhere($_eq: String = "", $_eq1: numeric = "") {
            requisitionCandidate: recruit_rstb_requisition_candidate(where: {recordStatus: {_eq: $_eq}, requisitionId: {_eq: $_eq1}}) {
                id
                requisitionId
                jobId
                candidateId
                candidate: hrm_hrtb_candidate {
                    fullname
                    firstName
                    lastName
                }
                status
                taskKey
                taskStatus
                offerStatus
                requisition: rstb_requisition {
                    id
                    code
                }
            }
            requisition: recruit_rstb_requisition(where: {recordStatus: {_eq: $_eq}, id: {_eq: $_eq1}}) {
                id
                jobs: rstb_requisition_jobs {
                    id
                    jobQuantity
                }
            }
        }`,
        variables: [
            "_eq", "_eq1"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstbRequisitionForDetailWhere: {
        query: `
        query hrmQueryRstbRequisitionForDetailWhere($_eq: numeric = "") {
            requisition: recruit_rstb_requisition(where: {id: {_eq: $_eq}}) {
                id
                aggId
                code
                status
                makerId
                description
                requirement
                specialNote
                sellingPoint
                gender
                departmentCode
                hiringManager
                reason: justification
                forEmployee
                urgency: priority
                isCritical: criticalFlg
                isSpecialERP: specialErpFlg
                requestForCompany
                delayNote
                surveyFlg
                reasonNotSurvey
                teamAssignmentId
                pendingFlg
                noneOfficialFlg
                specialErp: rstm_referral_program {
                    id
                    aggId
                    code
                    name
                }
                requestType: rstm_req_type {
                    code
                    name
                }
                requisitionJob: rstb_requisition_jobs {
                    id
                    requestQuantity: jobQuantity
                    hiredByRR: rrQuantity
                    hiredByDept: deptQuantity
                    internalSource: internalQuantity
                    jobQuantityDone
                    rrQuantityDone
                    deptQuantityDone
                    internalQuantityDone
                    jobTitleId
                    jobTitle
                    jobTrackId: jobPathId
                    jobTrack: jobPath
                    jobFamilyId
                    jobFamily
                    jobGroupId
                    jobGroup
                    subGroupId: jobSubgroupId
                    subGroup: jobSubgroup
                    personLevelId: jobLevelId
                    personLevel: jobLevel
                    jobTypeId
                    jobType
                    workingPlaceId: jobLocationId
                    workingPlace: jobLocation
                    educationLeveLId: jobEducationId
                    educationLevel: jobEducation
                    jobId
                    supportChangeEmpTypeFlg
                }
                skills: rstb_requisition_skills {
                    skill
                }
                stakeholders: rstb_requisition_stakeholders {
                    handledBy: involedEmployee
                    sharedHandledBy: sharedEmployee
                }
            }
        }`,
        variables: [
            "_eq"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstbRequisitionForDetailWithRequisitionCandidateWhere: {
        query: `
        query hrmQueryRstbRequisitionForDetailWithRequisitionCandidateWhere($_eq: String = "", $_eq1: numeric = "", $_eq2: numeric = "") {
            requisitionCandidate: recruit_rstb_requisition_candidate(where: {recordStatus: {_eq: $_eq}, requisitionId: {_eq: $_eq1}}) {
                id
                requisitionId
                candidateId
                taskId
                workflowId
                rootWorkflowId
                directErpFlg
                exEmployeeFlg
                exAccount
                memberAssignment: member_assignment_kpi {
                    assignedEmp: assigned_emp_id {
                        id
                        code
                        name
                        email
                    }
                }
            }
            pendingTime: recruit_v_requisition_total_pending_time(where: {requisition_id: {_eq: $_eq2}}) {
                raw_total_minutes
                total_minutes_excluding_weekends
            }
        }`,
        variables: [
            "_eq", "_eq1", "_eq2"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryRstbRequisitionForDetailWithRRWhere: {
        query: `
        query hrmQueryRstbRequisitionForDetailWithRRWhere($where1: recruit_v_stake_holder_dept_head_bool_exp = {}, $where2: recruit_v_stake_holder_dept_head_bool_exp = {}) {
            RRM: recruit_v_stake_holder_dept_head(where: $where1) {
                employeeId
                employeeCode
                employeeName
                employeeEmail
                stakeHolderId
            }
            RRBU: recruit_v_stake_holder_dept_head(where: $where2) {
                employeeId
                employeeCode
                employeeName
                employeeEmail
                stakeHolderId
            }
        }`,
        variables: [
            "where1", "where2"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING"
        ],
        function: []
    },
    hrmQueryHrtbParticipantDetailWhere: {
        query: `
        query hrmQueryHrtbParticipantDetailWhere($where1: hrm_hrtb_participant_bool_exp = {}, $where2: hrm_hrtb_worker_qualification_bool_exp = {}, $where3: recruit_pstb_event_participant_bool_exp = {}) {
            participant: hrm_hrtb_participant(where: $where1) {
                worker: hrtb_worker {
                id
                aggId
                homePhone
                fullName
                firstName
                genderId
                gender
                lastName
                mobile
                nationId
                nationalityId
                personalEmail
                nativeLanguageId
                porfolioLink
                code
                dob
                studentCode
                description
                qualifications: hrtb_worker_qualifications(where: $where2) {
                    facultyId
                    majoringId
                    makerDate
                    qualificationId
                    qualificationRateId
                    qualificationTypeId
                    schoolId
                    schoolYearStart
                    schoolYearEnd
                    issueDate
                    gpa
                    aggId
                    buCode
                    id
                }
                candidates: hrtb_candidates {
                    id
                    aggId
                }
                attachments: hrtb_worker_attachments {
                    id
                    attachmentRefno
                    attachmentTypeId
                }
                summaries: hrtb_worker_summaries {
                    id
                    jobTrackId
                    type: hrtm_summary_type {
                    code
                    }
                }
                }
                status
                sourceType
                sourceTypeId
                id
                makerDate
                aggId
            }
            participantEvent: recruit_pstb_event_participant(where: $where3) {
                status
                participantId
                aggId
                participantTypeId
                responseForm
                event: pstb_event {
                code
                id
                eventSource
                expectedParticipant
                externalPartner
                description
                name
                organizerName
                programId
                pstb_program {
                    banner
                    name
                    programTime
                    programDate
                }
                sourceType
                sourceTypeId
                sourceId
                }
                id
            }
        }`,
        variables: ["where1", "where2", "where3"],
        screen: ["SCREEN_RRM_STUDENT"],
        function: [],
    },
    hrmQueryRecruitPstbEventQuestionDetailWhere: {
        query: `
        query hrmQueryRecruitPstbEventQuestionDetailWhere($where: recruit_pstb_event_question_bool_exp) {
            data: recruit_pstb_event_question(where: $where) {
                question: qstb_question {
                    id
                    code
                    questionText
                    questionAnswer
                    updateDate
                    recordStatus
                    questionnaireId
                    questionTypeId
                    type: qstm_question_type {
                        name
                        id
                        code
                    }
                }
                dataType
                id
            }
        }`,
        variables: ["where"],
        screen: ["SCREEN_RRM_STUDENT"],
        function: [],
    },
    hrmQueryRecruitPstbEventQuestionnaireDetailWhere: {
        query: `
        query hrmQueryRecruitPstbEventQuestionnaireDetailWhere($where: recruit_pstb_event_questionnaire_bool_exp) {
            data: recruit_pstb_event_questionnaire(where: $where) {
                eventId
                questionnaire: qstm_questionnaire {
                id
                surveys: qstb_surveys {
                    question: qstb_question {
                        id
                        code
                        questionText
                        questionAnswer
                        updateDate
                        recordStatus
                        questionnaireId
                        questionTypeId
                        type: qstm_question_type {
                            name
                            id
                            code
                        }
                        dataType
                        }
                    }
                }
            }
        }`,
        variables: ["where"],
        screen: ["SCREEN_RRM_STUDENT"],
        function: [],
    },
    hrmQueryRecruitPstbQuestionResponsesWhere: {
        query: `
        query hrmQueryRecruitPstbQuestionResponsesWhere($where: recruit_pstb_question_response_bool_exp = {}) {
            data: recruit_pstb_question_response(where: $where) {
                answerDate
                answerText
                eventParticipantId
                questionId
                question: qstb_question {
                    id
                    questionText
                    code
                }
            }
        }`,
        variables: ["where"],
        screen: ["SCREEN_RRM_STUDENT"],
        function: [],
    },
    hrmQueryRecruitPstbProgramWhere: {
        query: `
        query hrmQueryRecruitPstbProgramWhere($where1: recruit_pstb_program_bool_exp = {}, $where2: recruit_pstm_webpage_template_bool_exp = {}, $where3: hrm_pltm_locality_bool_exp = {}, $where4: recruit_pstm_participant_type_bool_exp = {}, $where5: recruit_qstm_question_type_bool_exp = {}, $where6: recruit_gstm_rule_bool_exp = {}) {
            program: recruit_pstb_program(where: $where1) {
                id
                code
                name
            }
            webpageTemplate: recruit_pstm_webpage_template(where: $where2) {
                id
                code
                name
                url
            }
            locality: hrm_pltm_locality(where: $where3) {
                id
                code
                name
            }
            participantType: recruit_pstm_participant_type(where: $where4) {
                id
                code
                name
            }
            questionType: recruit_qstm_question_type(where: $where5) {
                id
                code
                name
            }
            rule: recruit_gstm_rule(where: $where6) {
                id
                code
                name
            }
            gift: recruit_gstb_gift {
                id
                code
                name
                recordStatus
            }
        }`,
        variables: [
            "where1",
            "where2",
            "where3",
            "where4",
            "where5",
            "where6"
        ],
        screen: ["SCREEN_RRM_PROGRAM_EVENT"],
        function: [],
    },
    hrmQueryGetAllStudentProgramByEventAggId: {
        query: `
        query hrmQueryGetAllStudentProgramByEventAggId($where: recruit_pstb_event_participant_bool_exp = {}) {
            data: recruit_pstb_event_participant(where: $where) {
                aggId
                participant: hrtb_participant {
                    worker: hrtb_worker {
                        fullName
                        personalEmail
                    }
                }
            }
        }`,
        variables: ["where"],
        screen: ["SCREEN_RRM_PROGRAM_EVENT"],
        function: [],
    },
    hrmQueryRecruitPstmFieldTypeWhere: {
        query: `
        query hrmQueryRecruitPstmFieldTypeWhere($where: recruit_pstm_field_type_bool_exp = {}) {
            data: recruit_pstm_field_type(where: $where) {
                id
                code
                name
            }
        }`,
        variables: ["where"],
        screen: ["SCREEN_RRM_PROGRAM_FIELD"],
        function: [],
    },
    hrmQueryRecruitPstmFieldGetFieldByAggIdWhere: {
        query: `
        query hrmQueryRecruitPstmFieldGetFieldByAggIdWhere($where: recruit_pstb_field_bool_exp = {}) {
          data: recruit_pstb_field(where: $where) {
              id
              code
              name
              title
              placeholder
              description
              required
              pattern
              uiComponent
              fieldTypeId
              format
              enums
              recordStatus
              systemFieldFlg
          }
        }`,
        variables: ["where"],
        screen: ["SCREEN_RRM_PROGRAM_FIELD"],
        function: [],
    },
    hrmQueryRecruitQstmQuestionTypeWhere: {
        query: `
        query hrmQueryRecruitQstmQuestionTypeWhere($where: recruit_qstm_question_type_bool_exp = {}, $where1: recruit_qstm_question_category_bool_exp = {}) {
            type: recruit_qstm_question_type(where: $where) {
                id
                code
                name
            }
            category: recruit_qstm_question_category(where: $where1) {
                id
                code
                name
            }
        }`,
        variables: ["where"],
        screen: ["SCREEN_RRM_PROGRAM_QUESTION"],
        function: [],
    },
    hrmQueryRecruitQstbQuestionWhere: {
        query: `
        query hrmQueryRecruitQstbQuestionWhere($where:recruit_qstb_question_bool_exp={}) {
            data: recruit_qstb_question(where: $where) {
                id
                code
                questionText
                questionTypeId
                questionCategoryId
                questionAnswer
                description
                requiredFlg
                recordStatus
                dataType
            }
        }`,
        variables: ["where"],
        screen: ["SCREEN_RRM_PROGRAM_QUESTION"],
        function: [],
    },
    hrmQueryRecruitGstmGiftTypeWhere: {
        query: `
            query hrmQueryRecruitGstmGiftTypeWhere($where: recruit_gstm_gift_type_bool_exp = {}) {
                type: recruit_gstm_gift_type(where: $where) {
                    id
                    code
                    name
                }
            }`,
        variables: ["where"],
        screen: ["SCREEN_RRM_PROGRAM_GIFTS"],
        function: [],
    },
    hrmQueryRecruitGstbGiftWhere: {
        query: `
        query hrmQueryRecruitGstbGiftWhere($where: recruit_gstb_gift_bool_exp = {}) {
            data: recruit_gstb_gift(where: $where) {
                id
                code
                name
                giftTypeId
                description
                imageIdentifier
                recordStatus
            }
        }`,
        variables: ["where"],
        screen: ["SCREEN_RRM_PROGRAM_GIFTS", "SCREEN_RRM_PROGRAM_QUESTION"],
        function: [],
    },
    hrmQueryRecruitRstmSurveyTypeWhere: {
        query: `
        query hrmQueryRecruitRstmSurveyTypeWhere($where1: recruit_rstm_survey_type_bool_exp = {}, $where2: recruit_rstb_survey_configure_bool_exp = {}) {
            type: recruit_rstm_survey_type(where: $where1) {
                id
                code
                name
            }
            config: recruit_rstb_survey_configure(where: $where2) {
                id
                surveyTypeId
                questionnaireId
            }
        }`,
        variables: ["where1", "where2"],
        screen: ["SCREEN_RRM_QUESTIONNAIRE_SURVEY"],
        function: [],
    },
    hrmQueryRecruitQstmQuestionnaireWhere: {
        query: `
        query hrmQueryRecruitQstmQuestionnaireWhere($where: recruit_qstm_questionnaire_bool_exp = {}) {
            data: recruit_qstm_questionnaire(where: $where) {
                id
                code
                name
            }
        }`,
        variables: ["where"],
        screen: ["SCREEN_RRM_QUESTIONNAIRE_SURVEY"],
        function: [],
    },
    hrmQueryRecruitQstmQuestionnaireGetFieldByAggIdWhere: {
        query: `
        query hrmQueryRecruitQstmQuestionnaireGetFieldByAggIdWhere($where1: recruit_qstm_questionnaire_bool_exp = {}, $where2: recruit_rstb_survey_configure_bool_exp = {}, $where3: recruit_qstb_survey_bool_exp = {}) {
            questionnaire: recruit_qstm_questionnaire(where: $where1) {
                id
                code
                name
                description
            }
            config: recruit_rstb_survey_configure(where: $where2) {
                surveyType: rstm_survey_type {
                    id
                }
            }
            survey: recruit_qstb_survey(where: $where3) {
                question: qstb_question {
                    id
                    code
                    questionText
                    description
                    dataType
                    requiredFlg
                    questionType: qstm_question_type {
                        code
                    }
                }
            }
        }`,
        variables: ["where1", "where2", "where3"],
        screen: ["SCREEN_RRM_QUESTIONNAIRE_SURVEY"],
        function: [],
    },
    hrmQueryGetAllMasterDataERPConfigWhere: {
        query: `
        query hrmQueryGetAllMasterDataERPConfigWhere($where1: hrm_tatm_level_bool_exp = {}, $where2: hrm_tatb_job_bool_exp = {}, $where3: hrm_tatb_job_bool_exp = {}, $where4: recruit_rstm_referral_exclusion_bool_exp = {}, $where5: recruit_rstm_referral_payment_bool_exp = {}, $where6: recruit_rstb_payment_phase_bool_exp = {}) {
            jobLevel: hrm_tatm_level(where: $where1) {
                id
                code
                name
            }
            jobFamily: hrm_tatb_job(where: $where2) {
                id
                code
                name
            }
            jobGroup: hrm_tatb_job(where: $where3) {
                id
                code
                name
                parentId
            }
            referralExclusion: recruit_rstm_referral_exclusion(where: $where4) {
                id
                code
                name
            }
            erpPayment: recruit_rstm_referral_payment(where: $where5) {
                id
                code
                name
            }
            paymentPhase: recruit_rstb_payment_phase(where: $where6) {
                id
                name
                priority
                recordOrder
                fromAmount
                toAmount
                paymentPercentage
                delayPeriod
                referralPaymentId
            }
        }`,
        variables: ["where1", "where2", "where3", "where4", "where5", "where6"],
        screen: ["SCREEN_CORE_RRM_ERP_CONFIG"],
        function: [],
    },
    hrmQueryGetAllMasterDataERPPaymentWhere: {
        query: `
        query hrmQueryGetAllMasterDataERPPaymentWhere($where1: hrm_tatm_level_bool_exp = {}, $where2: hrm_tatb_job_bool_exp = {}, $where3: hrm_tatb_job_bool_exp = {}, $where4: recruit_rstm_referral_exclusion_bool_exp = {}) {
            jobLevel: hrm_tatm_level(where: $where1) {
                id
                code
                name
            }
            jobFamily: hrm_tatb_job(where: $where2) {
                id
                code
                name
            }
            jobGroup: hrm_tatb_job(where: $where3) {
                id
                code
                name
                parentId
            }
            referralExclusion: recruit_rstm_referral_exclusion(where: $where4) {
                id
                code
                name
            }
        }`,
        variables: ["where1", "where2", "where3", "where4"],
        screen: ["SCREEN_CORE_RRM_ERP_PAYMENT"],
        function: [],
    },
    hrmQueryHrtbWorkerExistingWhere: {
        query: `
        query hrmQueryHrtbWorkerExistingWhere($where: hrm_hrtb_worker_bool_exp = {}, $where1: hrm_hrtb_worker_attachment_bool_exp = {}, $where2: hrm_hrtb_worker_social_bool_exp = {}) {
            data: hrm_hrtb_worker(where: $where) {
                id
                code
                aggId
                attachments: hrtb_worker_attachments(where: $where1) {
                    attachmentRefno
                    attachmentTypeId
                    aggId
                    id
                }
                socials: hrtb_worker_socials(where: $where2) {
                    id
                    aggId
                    channelId
                    socialLink
                    tenantCode
                    authStatus
                    description
                }
            }
        }`,
        variables: ["where", "where1", "where2"],
        screen: ["SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmQueryHrtbWorkerExistingWithCandidateWhere: {
        query: `
        query hrmQueryHrtbWorkerExistingWithCandidateWhere($where: hrm_hrtb_worker_bool_exp = {}) {
            data: hrm_hrtb_worker(where: $where) {
                id
                code
                aggId
                candidate: hrtb_candidates {
                    aggId
                    code
                    email
                    id
                    freshGraduateFlg
                    exEmployeeFlg
                    neverRecruitFlg
                    fresherFlg
                    neverRecruitNote
                    exAccount
                    autoMailFlg
                    autoMailDate
                    applyDate
                    currentSalary
                    expectedSalary
                    totalIncome
                    description
                    buCode
                    empCode
                    consentFlg
                    resumes: hrtb_candidate_resumes {
                        aggId
                        id
                        recommenders: hrtb_candidate_recommenders {
                            aggId
                            id
                            recommender
                            recommenderInfo
                        }
                        extRequestCode
                        internalRequestCode
                        status
                    }
                }
            }
        }`,
        variables: ["where"],
        screen: ["SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmQueryViewExEmployeeWhere: {
        query: `query hrmQueryViewExEmployeeWhere($where: hrm_v_ex_employee_bool_exp = {}) {
  data: hrm_v_ex_employee(where: $where) {
    id
    joinDate: join_date
    endDate: end_date
    subGroupName: sub_group_name
    jobGroupName: job_group_name
    jobFamilyName: job_family_name
    email
    domain
    employeeName: employee_name
    employeeCode: employee_code
    lineManager: line_manager
    departmentCode: department_code
    lastWorkingDateEmp: last_working_date_emp
  }
}
`,
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_EX_EMPLOYEE"
        ],
        function: []
    },
    hrmQueryRstbRequisitionForPostingWhere: {
        query: `
        query hrmQueryRstbRequisitionForPostingWhere($_eq: numeric = "") {
            rsRequisition: recruit_rstb_requisition(where: {id: {_eq: $_eq}}) {
                id
                aggId
                approvalDate
                authStatus
                buCode
                checkerDate
                checkerId
                closedDate
                createDate
                criticalFlg
                departmentCode
                description
                empCode
                ftsString
                ftsValue
                gender
                hiringManagerCode
                justification
                makerDate
                makerId
                modNo
                priority
                recordOrder
                recordStatus
                requirement
                workflowId
                updateId
                updateDate
                tenantCode
                status
                specialNote
                sellingPoint
                rsJobs: rstb_requisition_jobs {
                    id
                    requisitionId
                    jobQuantity
                    jobInfo
                    jobTitle
                    jobTrack
                    jobFamily
                    jobGroup
                    jobSubgroup
                    jobBenefit
                    jobCompetency
                    jobCompliance
                    jobDuty
                    jobEnvironment
                    jobLevel
                    jobLocation
                    jobOppotunity
                    jobPath
                    jobEducation
                    jobSalaryrange
                    jobType
                    jobWorkinghour
                    description
                    recordOrder
                    recordStatus
                    authStatus
                    makerId
                    makerDate
                    checkerId
                    checkerDate
                    modNo
                    createDate
                    ftsValue
                    ftsString
                    tenantCode
                    buCode
                    empCode
                    updateId
                    updateDate
                    aggId
                }
            }
        }`,
        variables: [
            "_eq"
        ],
        screen: [
            "SCREEN_RRM_MY_POST"
        ],
        function: []
    },
    hrmQueryRstbRequisitionForPostingFormWhere: {
        query: `
        query hrmQueryRstbRequisitionForPostingFormWhere($_eq: numeric = "") {
            data: recruit_rstb_requisition(where: {id: {_eq: $_eq}}) {
                id
                description
                status
                code
                approvalDate
                authStatus
                buCode
                campaignId
                checkerDate
                closedDate
                createDate
                criticalFlg
                departmentCode
                empCode
                forEmployee
                ftsString
                gender
                hiringManager
                justification
                name
                priority
                requirement
                requisitionTypeId
                rootWorkflowId
                sellingPoint
                specialErpFlg
                specialNote
                tenantCode
                updateDate
                workflowId
                requisitionJob: rstb_requisition_jobs {
                    jobFamily
                    jobGroup
                    jobInfo
                    jobId
                    jobType
                    tenantCode
                    jobTypeId
                    id
                    buCode
                    jobCompliance
                    jobCompetency
                    jobBenefit
                    jobDuty
                    jobEducation
                    jobEnvironment
                    jobLevel
                    jobLocation
                    jobOppotunity
                    jobPath
                    jobPathId
                    jobQuantity
                    jobSalaryrange
                    jobSubgroup
                    jobTitle
                    jobTrack
                    jobWorkinghour
                    description
                    ftsString
                    rrQuantity
                    requisitionId
                    makerDate
                    makerId
                }
                requisitionSkill: rstb_requisition_skills {
                    id
                    empCode
                    description
                    skill
                    skillId
                }
            }
        }`,
        variables: [
            "_eq"
        ],
        screen: [
            "SCREEN_RRM_MY_POST"
        ],
        function: []
    },
    hrmQueryCheckQuantityOfferDoneCandidate: {
        query: `
        query hrmQueryCheckQuantityOfferDoneCandidate($recordStatus: String = "", $requisitionId: numeric = "", $candidateId: numeric = "", $statusRequisitionAgg: String_comparison_exp = {}, $statusRequisitionAggOther: String_comparison_exp = {}, $statusCandidate: String_comparison_exp = {}) {
            requisition: recruit_rstb_requisition(where: {recordStatus: {_eq: $recordStatus}, id: {_eq: $requisitionId}}) {
                jobs: rstb_requisition_jobs {
                jobQuantity
                }
            }
            requisitionAggregate: recruit_rstb_requisition_candidate_aggregate(where: {recordStatus: {_eq: $recordStatus}, requisitionId: {_eq: $requisitionId}, status: $statusRequisitionAgg}) {
                aggregate {
                count(columns: aggId, distinct: true)
                }
            }
            requisitionAggregateOther: recruit_rstb_requisition_candidate_aggregate(where: {recordStatus: {_eq: $recordStatus}, requisitionId: {_eq: $requisitionId}, status: $statusRequisitionAggOther}) {
                aggregate {
                count(columns: aggId, distinct: true)
                }
            }
            candidateInfos: hrm_hrtb_candidate(where: {recordStatus: {_eq: $recordStatus}, id: {_eq: $candidateId}, status: $statusCandidate}) {
                id
                status
                staffMovementFlg
                changeEmpTypeFlg
            }
        }`,
        variables: ["recordStatus", "requisitionId", "candidateId", "statusRequisitionAgg", "statusRequisitionAggOther", "statusCandidate"],
        screen: ["SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmQueryRstbSurveyResponseWhere: {
        query: `
        query hrmQueryRstbSurveyResponseWhere($where: recruit_rstb_survey_response_bool_exp = {}) {
            data: recruit_rstb_survey_response(where: $where) {
                answerText
                answerDate
                answerPerson
                answerPersonName
                answerScore
                surveyStatus
                id
                qstb_question {
                    id
                    code
                    dataType
                    description
                    qstm_question_type {
                        code
                        name
                        id
                    }
                    questionText
                    questionAnswer
                    requiredFlg
                }
                requisitionId
                questionId
            }
        }`,
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_SURVEY_RESPONSE"
        ],
        function: []
    },
    hrmQueryViewErpPaymentInfoDetailsWhere: {
        query: "query hrmQueryViewErpPaymentInfoDetailsWhere($where: recruit_v_erp_payment_info_details_bool_exp = {}) { data: recruit_v_erp_payment_info_details(where: $where) { erpStatus reason jobFamilyId jobFamilyName jobGroupId jobGroupName paymentDate paymentRate paymentTime recommender requisitionCode status tenantCode titleOffer updateDate idRecommenderPayment department departmentDisplayPath candidateCode bonus candidateId paymentValue isSpecialErp aggId } }",
        variables: [
            "where"
        ],
        screen: [
            "SCREEN_RRM_ERP_PAYMENT_LINE"
        ],
        function: []
    },
    hrmQueryHrtbWorkerForCandidateGroupWhere: {
        query: `
        query hrmQueryHrtbWorkerForCandidateGroupWhere($_eq: uuid = "", $recordStatus: String = "") {
            worker: hrm_hrtb_worker(where: {aggId: {_eq: $_eq}}) {
                aggId
                candidate: hrtb_candidates(where: {recordStatus: {_eq: $recordStatus}}) {
                    email
                    hrtb_cgroup_details(where: {recordStatus: {_eq: $recordStatus}}) {
                        hrtb_candidate_group {
                            hrtb_cgroup_details(where: {recordStatus: {_eq: $recordStatus}}) {
                                hrtb_candidate {
                                    id
                                    email
                                    recruitSource
                                    recruitSourceId
                                    sourceType
                                    sourceTypeId
                                    applyDate
                                    currentSalary
                                    expectedSalary
                                    allowance
                                    bonus
                                    neverRecruitFlg
                                    neverRecruitNote
                                    exEmployeeFlg
                                    exAccount
                                    staffMovementFlg
                                    changeEmpTypeFlg
                                    fresherFlg
                                    freshGraduateFlg
                                    consentFlg
                                    updateDate
                                    hrtb_worker {
                                        aggId
                                        studentCode
                                        attachments: hrtb_worker_attachments(where: {recordStatus: {_eq: $recordStatus}}) {
                                            attachmentTypeId
                                            attachmentRefno
                                            id
                                            workerId
                                            aggId
                                            extraInfo
                                            recruitSourceId
                                            sourceTypeId
                                            recruitSource
                                            sourceType
                                            usingFlg
                                            updateId
                                            updateDate
                                            makerId
                                            makerDate
                                            attachmentType: hrtm_attachment_type {
                                                code
                                                aggId
                                                id
                                                description
                                                name
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }`,
        variables: [
            "_eq", "recordStatus"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE", "SCREEN_RRM_CANDIDATE_GROUP"
        ],
        function: []
    },
    hrmQueryHrtbWorkerForDetailWhere: {
        query: `
        query hrmQueryHrtbWorkerForDetailWhere($_eq: uuid = "") {
            worker: hrm_hrtb_worker(where: {aggId: {_eq: $_eq}}) {
                id
                code
                aggId
                dob
                ethnicityId
                firstName
                lastName
                middleName
                fullName
                gender
                homePhone
                mobile
                maritalStatusId
                nationId
                pobId
                nationalityId
                personalEmail
                porfolioLink
                professionId
                status
                studentCode
                workerTypeId
                religionId
                tenantCode
                nativeLanguageId
                nationality: hrtm_nationality {
                    id
                    code
                    name
                    description
                }
                pltmCountry: pltm_country {
                    id
                    code
                    code3
                    name
                    description
                }
                pltmLocality: pltm_locality {
                    id
                    code
                    name
                    isCapital
                    localityTypeId
                    parentId
                }
                maritalStatus: hrtm_marital_status {
                    id
                    code
                    name
                    description
                }
            }
        }`,
        variables: [
            "_eq"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbWorkerQualificationForWorkerDetailWhere: {
        query: `
        query hrmQueryHrtbWorkerQualificationForWorkerDetailWhere($_eq: uuid = "", $recordStatus: String = "") {
            qualifications: hrm_hrtb_worker_qualification(where: {recordStatus: {_eq: $recordStatus}, hrtb_worker: {aggId: {_eq: $_eq}}}) {
                recordStatus
                facultyId
                gpa
                aggId
                description
                id
                issueDate
                majoringId
                mainFlg
                makerDate
                country: pltm_country {
                    aggId
                    code
                    code3
                    description
                    name
                }
                schoolId
                schoolYearStart
                schoolYearEnd
                workerId
                qualificationId
                qualificationRateId
                qualificationTypeId
                receivedHardcopyFlg
                overseaId
                qualificationAttachment: hrtb_worker_qualify_attachments(where: {recordStatus: {_eq: $recordStatus}}) {
                    attachmentTypeId
                    attachmentRefno
                    aggId
                    id
                    workerQualifyId
                    extraInfo
                }
            }
        }`,
        variables: [
            "_eq", "recordStatus"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbCandidateForWorkerDetailWhere: {
        query: `
        query hrmQueryHrtbCandidateForWorkerDetailWhere($_eq: uuid = "", $recordStatus: String = "") {
            candidate: hrm_hrtb_candidate(where: {recordStatus: {_eq: $recordStatus}, hrtb_worker: {aggId: {_eq: $_eq}}}) {
                currentSalary
                allowance
                bonus
                code
                exAccount
                exEmployeeFlg
                expectedSalary
                freshGraduateFlg
                fresherFlg
                ftsString
                ftsValue
                neverRecruitFlg
                neverRecruitNote
                id
                recruitSource
                recruitSourceId
                sourceType
                sourceTypeId
                status
                workerId
                totalIncome
                description
                staffMovementFlg
                changeEmpTypeFlg
                applyDate
                aggId
                homeAddress
                consentFlg
                email
                avatarFile
                resumes: hrtb_candidate_resumes(where: {recordStatus: {_eq: $recordStatus}}) {
                    aggId
                    candidateId
                    id
                    extRequestCode
                    internalRequestCode
                    applyDate
                    recommenders: hrtb_candidate_recommenders(where: {recordStatus: {_eq: $recordStatus}}) {
                        candidateResumeId
                        aggId
                        createDate
                        erpMailFlg
                        erpStatus
                        employeeId
                        recommender
                        recommenderInfo
                        tenantCode
                        referralProgramId
                        makerDate
                        makerId
                        unpaidReason
                        unpaymentReason
                        id
                        description
                        applyDate
                        recordStatus
                    }
                    sourceType
                    recruitSource
                    status
                    tenantCode
                    description
                }
            }
        }`,
        variables: [
            "_eq", "recordStatus"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbWorkerRecordForWorkerDetailWhere: {
        query: `
        query hrmQueryHrtbWorkerRecordForWorkerDetailWhere($_eq: uuid = "", $recordStatus: String = "") {
            workingBackgrounds: hrm_hrtb_worker_record(where: {recordStatus: {_eq: $recordStatus}, hrtb_worker: {aggId: {_eq: $_eq}}}) {
                companyName
                aggId
                currentFlg
                description
                extraInfo
                id
                industryId
                jobTitleId
                jobTitle
                jobTypeId
                mainTask
                offWorkDate
                offWorkReason
                overseaId
                relevantCompanyFlg
                workerId
                workingDate
                tenantCode
            }
        }`,
        variables: [
            "_eq", "recordStatus"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbWorkerRefpersonForWorkerDetailWhere: {
        query: `
        query hrmQueryHrtbWorkerRefpersonForWorkerDetailWhere($_eq: uuid = "", $recordStatus: String = "") {
            refPersons: hrm_hrtb_worker_refperson(where: {recordStatus: {_eq: $recordStatus}, hrtb_worker: {aggId: {_eq: $_eq}}}) {
                description
                id
                refPerson
                refTitleId
                relationId
                refTitle
                workerId
                phone
                aggId
                companyName
            }
        }`,
        variables: [
            "_eq", "recordStatus"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbWorkerAttachmentForWorkerDetailWhere: {
        query: `
        query hrmQueryHrtbWorkerAttachmentForWorkerDetailWhere($_eq: uuid = "", $recordStatus: String = "") {
            attachments: hrm_hrtb_worker_attachment(where: {recordStatus: {_eq: $recordStatus}, hrtb_worker: {aggId: {_eq: $_eq}}}) {
                attachmentTypeId
                attachmentRefno
                id
                workerId
                aggId
                extraInfo
                recruitSourceId
                sourceTypeId
                recruitSource
                sourceType
                usingFlg
                updateId
                updateDate
                makerId
                makerDate
                extractedText
                extractedInfo
                attachmentType: hrtm_attachment_type {
                    id
                    code
                    name
                    aggId
                    description
                }
            }
        }`,
        variables: [
            "_eq", "recordStatus"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbWorkerLegaldocForWorkerDetailWhere: {
        query: `
        query hrmQueryHrtbWorkerLegaldocForWorkerDetailWhere($_eq: uuid = "", $recordStatus: String = "") {
            legadoc: hrm_hrtb_worker_legaldoc(where: {recordStatus: {_eq: $recordStatus}, hrtb_worker: {aggId: {_eq: $_eq}}}) {
                aggId
                identityNo
                issueDate
                expiredDate
                issuePlace
                issuePlaceId
                legaldocTypeId
                workerId
                tenantCode
            }
        }`,
        variables: [
            "_eq", "recordStatus"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbWorkerSummaryForWorkerDetailWhere: {
        query: `
        query hrmQueryHrtbWorkerSummaryForWorkerDetailWhere($_eq: uuid = "", $recordStatus: String = "") {
            summaries: hrm_hrtb_worker_summary(where: {recordStatus: {_eq: $recordStatus}, hrtb_worker: {aggId: {_eq: $_eq}}}) {
                id
                aggId
                description
                tenantCode
                workerId
                updateId
                updateDate
                makerId
                makerDate
                summaryTypeId
                jobTrackId
                skillId
                summary: hrtm_summary_type {
                    id
                    code
                    name
                    aggId
                    description
                    checkerId
                }
            }
        }`,
        variables: [
            "_eq", "recordStatus"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbWorkerAddressForWorkerDetailWhere: {
        query: `
        query hrmQueryHrtbWorkerAddressForWorkerDetailWhere($_eq: uuid = "", $recordStatus: String = "") {
            address: hrm_hrtb_worker_address(where: {recordStatus: {_eq: $recordStatus}, hrtb_worker: {aggId: {_eq: $_eq}}}) {
                id
                aggId
                regAddress
                regLocalityId
                regFulladdress
                actAddress
                actLocalityId
                actFulladdress
                pltmLocality: pltm_locality {
                    id
                    code
                    name
                }
            }
        }`,
        variables: [
            "_eq", "recordStatus"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryHrtbWorkerSocialForWorkerDetailWhere: {
        query: `
        query hrmQueryHrtbWorkerSocialForWorkerDetailWhere($_eq: uuid = "", $recordStatus: String = "") {
            socials: hrm_hrtb_worker_social(where: {recordStatus: {_eq: $recordStatus}, hrtb_worker: {aggId: {_eq: $_eq}}}) {
                channelId
                extraInfo
                socialLink
                tenantCode
                workerId
                aggId
                makerDate
                makerId
            }
        }`,
        variables: [
            "_eq", "recordStatus"
        ],
        screen: [
            "SCREEN_RRM_CANDIDATE"
        ],
        function: []
    },
    hrmQueryCandidateResolver: {
        query: `
        query hrmQueryCandidateResolver($where: hrm_tatm_gender_bool_exp = {}, 
            $where1: hrm_hrtm_source_type_bool_exp = {}, 
            $where2: hrm_hrtm_source_type_bool_exp = {}, 
            $where3: hrm_hrtm_source_type_bool_exp = {}, 
            $where4: hrm_hrtb_worker_relation_bool_exp = {}, 
            $where5: hrm_pltm_country_bool_exp = {}, 
            $where6: hrm_tatm_qualification_type_bool_exp = {}, 
            $where7: hrm_tatm_school_bool_exp = {},
            $where8: hrm_tatm_qualification_bool_exp = {},
            $where9: hrm_tatm_majoring_bool_exp = {},
            $where10: hrm_tatm_faculty_bool_exp = {},
            $where11: hrm_tatm_qualification_rate_bool_exp = {}
            $where12: hrm_tatm_industry_bool_exp = {},
            $where13: hrm_hrtm_nationality_bool_exp = {},
            $where14: hrm_hrtm_legaldoc_type_bool_exp = {}) {
            gender: hrm_tatm_gender(where: $where) {
                id
                code
                name
            }
            allSourceType: hrm_hrtm_source_type(where: $where1) {
                id
                code
                name
                description
                channelTypeId: parentId
                category: hrtm_source_category {
                code
                }
            }
            sourceType: hrm_hrtm_source_type(where: $where2) {
                id
                code
                name
                description
                channelTypeId: parentId
            }
            source: hrm_hrtm_source_type(where: $where3) {
                id
                code
                name
                description
                channelTypeId: parentId
            }
            contactType: hrm_hrtb_worker_relation(where: $where4) {
                id
                relationName
                workerId
            }
            country: hrm_pltm_country(where: $where5) {
                id
                code
                name
                aggId
                description
                code3
                currencyId
            }
            qualificationType: hrm_tatm_qualification_type(where: $where6) {
                id
                code
                name
            }
            university: hrm_tatm_school(where: $where7) {
                id
                code
                name
                city
                schoolTypeId
            }
            qualification: hrm_tatm_qualification(where: $where8) {
                id
                code
                name
                qualificationTypeId
            }
            major: hrm_tatm_majoring(where: $where9) {
                id
                code
                name
                facultyId
            }
            faculty: hrm_tatm_faculty(where: $where10) {
                id
                code
                name
                schoolId
            }
            qualificationRate: hrm_tatm_qualification_rate(where: $where11) {
                id
                code
                name
            }
            industry: hrm_tatm_industry(where: $where12) {
                id
                code
                name
            }
            nationality: hrm_hrtm_nationality(where: $where13) {
                id
                code
                name
            }
            legaldocType: hrm_hrtm_legaldoc_type(where: $where14) {
                id
                code
                name
            }
        }`,
        variables: [
            "where", "where1", "where2", "where3", "where4", "where5", "where6", "where7", "where8", "where9", "where10", "where11", "where12", "where13", "where14"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryCandidateExtResolver: {
        query: `
        query hrmQueryCandidateExtResolver($where: hrm_tatm_type_bool_exp = {}, 
            $where1: hrm_tatb_job_bool_exp = {}, 
            $where2: hrm_tatb_job_bool_exp = {}, 
            $where3: hrm_tatb_job_bool_exp = {}, 
            $where4: hrm_tatb_job_bool_exp = {}, 
            $where5: hrm_pltm_issuing_authorities_bool_exp = {}, 
            $where6: hrm_hrtm_attachment_type_bool_exp = {}, 
            $where7: hrm_hrtm_marital_status_bool_exp = {},
            $where9: hrm_hrtb_office_bool_exp = {},
            $where10: hrm_hrtm_relation_bool_exp = {},
            $where11: hrm_hrtm_summary_type_bool_exp = {}
            $where12: recruit_rstm_channel_bool_exp = {},
            $where13: hrm_tatm_level_bool_exp = {}) {
            jobType: hrm_tatm_type(where: $where) {
                id
                code
                name
                aggId
            }
            jobTrack: hrm_tatb_job(where: $where1) {
                id
                code
                name
                parentId
            }
            jobFamily: hrm_tatb_job(where: $where2) {
                id
                code
                name
                parentId
            }
            jobGroup: hrm_tatb_job(where: $where3) {
                id
                code
                name
                parentId
            }
            subGroup: hrm_tatb_job(where: $where4) {
                id
                code
                name
                parentId
            }
            issuePlace: hrm_pltm_issuing_authorities(where: $where5) {
                id
                code
                name
            }
            attachmentType: hrm_hrtm_attachment_type(where: $where6) {
                id
                code
                name
            }
            maritalStatus: hrm_hrtm_marital_status(where: $where7) {
                id
                code
                name
            }
            office: hrm_hrtb_office(where: $where9) {
                id
                code
                name
            }
            relation: hrm_hrtm_relation(where: $where10) {
                id
                code
                name
                updateId
            }
            summaryType: hrm_hrtm_summary_type(where: $where11) {
                id
                code
                name
                aggId
            }
            channel: recruit_rstm_channel(where: $where12) {
                id
                code
                name
            }
            employeeLevel: hrm_tatm_level(where: $where13) {
                id
                code
                name
            }
        }`,
        variables: [
            "where", "where1", "where2", "where3", "where4", "where5", "where6", "where7", "where9", "where10", "where11", "where12", "where13"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryPostResolver: {
        query: `
        query hrmQueryPostResolver($where: hrm_tatb_job_bool_exp = {}, 
            $where1: hrm_tatb_job_bool_exp = {}, 
            $where2: hrm_tatm_skill_bool_exp = {}, 
            $where3: hrm_tatm_type_bool_exp = {}, 
            $where4: hrm_hrtm_product_group_bool_exp = {}, 
            $where5: recruit_rstm_channel_bool_exp = {}, 
            $where6: connect_cstm_channel_bool_exp = {}, 
            $where7: hrm_pltm_locality_bool_exp = {},
            $where8: hrm_tatm_career_path_bool_exp = {}) {
            jobFamily: hrm_tatb_job(where: $where) {
                id
                code
                name
                parentId
            }
            jobGroup: hrm_tatb_job(where: $where1) {
                id
                code
                name
                parentId
            }
            jobSkill: hrm_tatm_skill(where: $where2) {
                id
                code
                name
            }
            jobType: hrm_tatm_type(where: $where3) {
                id
                code
                name
                aggId
            }
            productGroup: hrm_hrtm_product_group(where: $where4) {
                id
                code
                name
            }
            channel: recruit_rstm_channel(where: $where5) {
                id
                code
                name
            }
            userChannel: connect_cstm_channel(where: $where6) {
                id
                code
                name
            }
            province: hrm_pltm_locality(where: $where7) {
                id
                code
                name
                aggId
                parentId
                countryId
                country: pltm_country {
                    id
                    code
                    name
                    aggId
                    code3
                }
                type: pltm_locality_type {
                    id
                    code
                    name
                }
            }
            jobTrack: hrm_tatm_career_path(where: $where8) {
                id
                code
                name
            }
        }`,
        variables: [
            "where", "where1", "where2", "where3", "where4", "where5", "where6", "where7", "where8"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryJobApplyResolver: {
        query: `
        query hrmQueryJobApplyResolver($where: hrm_hrtm_attachment_type_bool_exp = {}, 
            $where1: hrm_hrtm_source_type_bool_exp = {}, 
            $where2: hrm_hrtm_source_type_bool_exp = {}, 
            $where3: recruit_rstm_channel_bool_exp = {}) {
            attachmentType: hrm_hrtm_attachment_type(where: $where) {
                id
                code
                name
            }
            recruitSource: hrm_hrtm_source_type(where: $where1) {
                id
                code
                name
                description
                channelTypeId: parentId
            }
            sourceType: hrm_hrtm_source_type(where: $where2) {
                id
                code
                name
                description
                channelTypeId: parentId
            }
            channel: recruit_rstm_channel(where: $where3) {
                id
                code
                name
            }
        }`,
        variables: [
            "where", "where1", "where2", "where3"
        ],
        screen: [
            "SCREEN_RRM_TASK",
            "SCREEN_RRM_TRACKING",
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_STUDENT"
        ],
        function: []
    },
    hrmQueryCandidateGroupForValidTransfer: {
        query: `
        query hrmQueryCandidateGroupForValidTransfer($_in: [numeric!] = "", $recordStatus: String = "") {
            worker: hrm_hrtb_worker(where: {id: {_in: $_in}}) {
                candidate: hrtb_candidates(where: {recordStatus: {_eq: $recordStatus}}) {
                    email
                    mobile
                    fullname
                    details: hrtb_cgroup_details(where: {recordStatus: {_eq: $recordStatus}}) {
                        group: hrtb_candidate_group {
                            details: hrtb_cgroup_details(where: {recordStatus: {_eq: $recordStatus}}) {
                                candidate: hrtb_candidate {
                                    id
                                    email
                                    mobile
                                    fullname
                                }
                            }
                        }
                    }
                }
            }
        }`,
        variables: [
            "_in", "recordStatus"
        ],
        screen: [
            "FUNC_MUTATION_FOR_TASK",
        ],
        function: []
    },
}